import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { ToasterService } from '../services/toaster.service';
import { catchError } from 'rxjs/operators';

@Injectable()
export class HttpErrorInterceptorService implements HttpInterceptor {

  constructor(private toastService: ToasterService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {

        let errorMessage = 'Something went wrong';

        switch (error.status) {
          case 400: errorMessage = 'Invalid request'; break;
          case 401:
          case 403: errorMessage = 'Permission denied'; break;
          case 404: errorMessage = 'Item not found'; break;
          case 500: errorMessage = 'Internal server error'; break;
        }

        this.toastService.error(errorMessage);
        return throwError(() => error);
      })
    );
  }
}
